import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _styled from "styled-components";
import { Tab } from '@headlessui/react';
import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { Button } from '../button';
import { Popover, Trigger } from '../popover';
import Paragraph from '../paragraph';
import { useResponsiveBreakPoints } from '@restworld/utils-common';
import { fontColorMap } from '../button/button.constant';
import { CvParsingLoadingState } from './cv-parsing-loading-state';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CustomTabs = function CustomTabs(_ref) {
  var tabs = _ref.tabs,
      tabPanelStyling = _ref.tabPanelStyling,
      buttonStyling = _ref.buttonStyling,
      tabListStyling = _ref.tabListStyling,
      _ref$isSticky = _ref.isSticky,
      isSticky = _ref$isSticky === void 0 ? false : _ref$isSticky,
      onTabChange = _ref.onTabChange,
      defaultTab = _ref.defaultTab,
      hasBorderBottom = _ref.hasBorderBottom,
      _ref$mobileStickyTopP = _ref.mobileStickyTopPx,
      mobileStickyTopPx = _ref$mobileStickyTopP === void 0 ? 74 : _ref$mobileStickyTopP,
      _ref$desktopStickyTop = _ref.desktopStickyTopPx,
      desktopStickyTopPx = _ref$desktopStickyTop === void 0 ? 88 : _ref$desktopStickyTop,
      _ref$centerTabs = _ref.centerTabs,
      centerTabs = _ref$centerTabs === void 0 ? false : _ref$centerTabs;

  var _useState = useState(0),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var tabRef = useRef(null);

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isDesktop = _useResponsiveBreakPo.isDesktop;

  var navbarHeight = isDesktop ? desktopStickyTopPx : mobileStickyTopPx;
  useEffect(function () {
    if (defaultTab !== undefined && tabRef !== null && tabRef !== void 0 && tabRef.current) {
      var tabAtIndex = tabRef.current.children[defaultTab];

      if (tabAtIndex) {
        var _tabRef$current;

        tabAtIndex.click();
        tabRef === null || tabRef === void 0 ? void 0 : (_tabRef$current = tabRef.current) === null || _tabRef$current === void 0 ? void 0 : _tabRef$current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  }, [defaultTab]);
  useEffect(function () {
    if (defaultTab !== undefined) {
      var _tabRef$current2;

      var _tabs = (_tabRef$current2 = tabRef.current) === null || _tabRef$current2 === void 0 ? void 0 : _tabRef$current2.children;

      if (_tabs && _tabs[defaultTab]) {
        _tabs[defaultTab].click();
      }
    }
  }, [defaultTab]);
  useEffect(function () {
    if (tabRef.current) {
      var activeTabElement = tabRef.current.querySelector('[data-headlessui-state="selected"]');

      if (activeTabElement) {
        activeTabElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }, [activeTab]);
  var onHandleTabChange = useCallback(function (index) {
    setActiveTab(index);

    if (onTabChange) {
      onTabChange(index);
    }
  }, [onTabChange]);
  return /*#__PURE__*/_jsxs(Tab.Group, {
    defaultIndex: activeTab,
    onChange: function onChange(index) {
      return onHandleTabChange(index);
    },
    children: [/*#__PURE__*/_jsx(StyledTabList, {
      $tabListStyling: tabListStyling,
      ref: tabRef,
      $isDesktop: isDesktop,
      $hasBorderBottom: hasBorderBottom,
      $mobileStickyTopPx: mobileStickyTopPx,
      $desktopStickyTopPx: desktopStickyTopPx,
      $isSticky: isSticky,
      $centerTabs: centerTabs,
      children: tabs.map(function (_ref2, index) {
        var label = _ref2.label,
            _ref2$isActive = _ref2.isActive,
            isActive = _ref2$isActive === void 0 ? true : _ref2$isActive,
            hoverMessage = _ref2.hoverMessage,
            icon = _ref2.icon,
            buttonIcon = _ref2.buttonIcon,
            buttonActiveIcon = _ref2.buttonActiveIcon,
            buttonType = _ref2.buttonType,
            activeButtonType = _ref2.activeButtonType,
            badgeLabel = _ref2.badgeLabel,
            _ref2$fontColor = _ref2.fontColor,
            fontColor = _ref2$fontColor === void 0 ? 'black' : _ref2$fontColor,
            _ref2$activeFontColor = _ref2.activeFontColor,
            activeFontColor = _ref2$activeFontColor === void 0 ? 'white' : _ref2$activeFontColor,
            twStyle = _ref2.twStyle,
            activeTwStyle = _ref2.activeTwStyle,
            fontWeight = _ref2.fontWeight;
        return /*#__PURE__*/_jsx(Tab, {
          as: Fragment,
          children: function children(_ref3) {
            var selected = _ref3.selected;

            if (isActive) {
              return /*#__PURE__*/_jsx(Button, {
                disabled: !isActive,
                variant: selected ? activeButtonType || 'primary' : buttonType || 'gray-50',
                icon: selected ? buttonActiveIcon : buttonIcon,
                fontColor: selected ? activeFontColor : fontColor,
                fitContent: true,
                twStyle: buttonStyling || (selected ? activeTwStyle : twStyle),
                fontWeight: fontWeight,
                children: /*#__PURE__*/_jsxs(_StyledDiv, {
                  children: [icon && /*#__PURE__*/_jsx(IconContainer, {
                    selected: selected,
                    iconColor: selected ? activeFontColor : fontColor,
                    children: icon
                  }), label, badgeLabel && /*#__PURE__*/_jsx(BadgeContainer, {
                    children: /*#__PURE__*/_jsx("span", {
                      children: badgeLabel
                    })
                  })]
                })
              }, index);
            } else {
              return /*#__PURE__*/_jsxs(Popover, {
                trigger: Trigger.HOVER,
                buttonTwStyle: {
                  "borderRadius": "0.5rem",
                  "paddingLeft": "1rem",
                  "paddingRight": "1rem",
                  "paddingTop": "0.75rem",
                  "paddingBottom": "0.75rem",
                  "fontWeight": "500"
                },
                children: [/*#__PURE__*/_jsx(Popover.Button, {
                  children: /*#__PURE__*/_jsx("span", {
                    children: label
                  })
                }), /*#__PURE__*/_jsx(Popover.Panel, {
                  children: /*#__PURE__*/_jsx(Paragraph, {
                    variant: "body",
                    color: "gray-500",
                    twStyle: {
                      "whiteSpace": "nowrap",
                      "--tw-text-opacity": "1",
                      "color": "rgb(28 19 39 / var(--tw-text-opacity))"
                    },
                    children: hoverMessage
                  })
                })]
              }, index);
            }
          }
        }, index);
      })
    }), /*#__PURE__*/_jsx(_StyledTabPanels, {
      children: tabs.map(function (_ref4, index) {
        var content = _ref4.content,
            isLoading = _ref4.isLoading;
        return /*#__PURE__*/_jsx(StyledTabPanel, {
          $tabPanelStyling: tabPanelStyling,
          children: isLoading ? /*#__PURE__*/_jsx(CvParsingLoadingState, {}) : content
        }, index);
      })
    })]
  });
};

var IconContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "custom-tabs__IconContainer",
  componentId: "sc-1jsb73j-0"
})(["", ""], function (_ref5) {
  var iconColor = _ref5.iconColor;
  return fontColorMap[iconColor];
});

var StyledTabPanel = /*#__PURE__*/_styled(Tab.Panel).withConfig({
  displayName: "custom-tabs__StyledTabPanel",
  componentId: "sc-1jsb73j-1"
})(function (_ref6) {
  var twStyle = _ref6.$tabPanelStyling;
  return [{
    "marginTop": "1.5rem",
    "padding": "0px"
  }].concat(_toConsumableArray(twStyle && Array.isArray(twStyle) ? twStyle : []), [twStyle && !Array.isArray(twStyle) ? twStyle : {}]);
});

var StyledTabList = /*#__PURE__*/_styled(Tab.List).withConfig({
  displayName: "custom-tabs__StyledTabList",
  componentId: "sc-1jsb73j-2"
})(function (_ref7) {
  var twStyle = _ref7.$tabListStyling,
      $isSticky = _ref7.$isSticky,
      $isDesktop = _ref7.$isDesktop,
      $hasBorderBottom = _ref7.$hasBorderBottom,
      $mobileStickyTopPx = _ref7.$mobileStickyTopPx,
      $desktopStickyTopPx = _ref7.$desktopStickyTopPx,
      $centerTabs = _ref7.$centerTabs;
  return [{
    "marginBottom": "1rem",
    "display": "flex",
    "maxWidth": "100%",
    "> :not([hidden]) ~ :not([hidden])": {
      "--tw-space-x-reverse": "0",
      "marginRight": "calc(1rem * var(--tw-space-x-reverse))",
      "marginLeft": "calc(1rem * calc(1 - var(--tw-space-x-reverse)))"
    },
    "overflowX": "auto",
    "paddingLeft": "0.25rem",
    "paddingRight": "0.25rem",
    "paddingTop": "1.5rem",
    "paddingBottom": "0.25rem",
    "scrollbarWidth": "none",
    "::-webkit-scrollbar": {
      "display": "none"
    }
  }, $centerTabs ? {
    "justifyContent": "center"
  } : {}].concat(_toConsumableArray(twStyle && Array.isArray(twStyle) ? twStyle : []), [twStyle && !Array.isArray(twStyle) ? twStyle : {}, $isSticky ? {
    "position": "sticky",
    "left": "0px",
    "right": "0px",
    "zIndex": "30",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
    "paddingTop": "1rem",
    "paddingBottom": "1.5rem"
  } : {}, {
    top: $isSticky ? "".concat($isDesktop ? $desktopStickyTopPx : $mobileStickyTopPx, "px") : undefined
  }, $hasBorderBottom ? {
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))"
  } : {}]);
});

export var BadgeContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "custom-tabs__BadgeContainer",
  componentId: "sc-1jsb73j-3"
})(function () {
  return [{
    "display": "flex",
    "height": "1.5rem",
    "minHeight": "24px",
    "width": "1.5rem",
    "minWidth": "24px",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "9999px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(221 238 52 / var(--tw-bg-opacity))",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "fontWeight": "600",
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))"
  }];
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "custom-tabs___StyledDiv",
  componentId: "sc-1jsb73j-4"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.5rem"
});

var _StyledTabPanels = /*#__PURE__*/_styled(Tab.Panels).withConfig({
  displayName: "custom-tabs___StyledTabPanels",
  componentId: "sc-1jsb73j-5"
})({
  "width": "100%"
});